import { render, staticRenderFns } from "./BotStats.vue?vue&type=template&id=9fdfa2aa&scoped=true&"
import script from "./BotStats.vue?vue&type=script&lang=js&"
export * from "./BotStats.vue?vue&type=script&lang=js&"
import style0 from "./BotStats.vue?vue&type=style&index=0&id=9fdfa2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdfa2aa",
  null
  
)

export default component.exports